import React from "react"
import { MediumText } from "@/UI"

interface EmptySettingBoxProps {
  id?: string
  title?: string
  icon: JSX.Element
  description: string
  button?: JSX.Element
  fixedSize?: boolean
}

const EmptySettingBox: React.FC<EmptySettingBoxProps> = ({
  id,
  title,
  icon,
  description,
  button,
  fixedSize,
}) => {
  return (
    <div
      id={id}
      className="flex flex-col gap-y-4 mb-2 text-center"
      style={{ ...(fixedSize ? { width: 300, height: 250 } : {}) }}
    >
      {title && <MediumText>{title}</MediumText>}
      <div className="flex flex-col w-full h-full px-4 pt-6 pb-8 rounded-md border items-center justify-between gap-y-4">
        <div className="flex flex-col gap-y-2 items-center">
          {icon}
          <p
            className={`text-gray-600 ${
              fixedSize ? "font-semibold text-md" : "font-medium text-lg"
            }`}
          >
            {description}
          </p>
        </div>
        {button}
      </div>
    </div>
  )
}

export default EmptySettingBox
